module.exports = ".thumbnail{height:170px}.barcode-container{width:336px;height:105.6px;margin-left:40%;margin-top:50px;border:2px solid black}\n"